import { FileDocumentArrowRightIcon } from './FileDocumentArrowRightIcon';

/**
 * author: Andrej Sharapov
 * id 31314AE5-195A-4F48-847C-AC6D8A69360D
 * name file-document-arrow-right
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-arrow-right.svg
 * tags
 * - Files / Folders 
 */
export const FileTextMoveIcon = FileDocumentArrowRightIcon;
export default FileTextMoveIcon